import React from 'react';
import style from './OpenPositions.module.css';
import { OpenAllTable } from './collections/OpenAllTable';

export const OpenPositions = () => {
  return (
    <div className={style.tableContainer}>
      <table className={style.table}>
        <OpenAllTable />
      </table>
    </div>
  );
};
